import React from 'react';
import {
  Card,
  CardContent,
  Typography,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Box,
  Chip,
} from '@mui/material';
import {
  SHARED_TYPOGRAPHY,
  SHARED_STATUS,
  getStatusStyles,
  getStatusTextStyles,
} from '../../../theme';

const AdapterStatusTable = ({ adapters }) => {
  if (!adapters || !adapters.adapters || adapters.adapters.length === 0)
    return null;

  return (
    <Card>
      <CardContent>
        <Typography variant="h5" sx={{ mb: 2, ...SHARED_TYPOGRAPHY.h5Bold }}>
          Adapter Status for Tenant
        </Typography>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Provider</TableCell>
                <TableCell>Models</TableCell>
                <TableCell align="center">Status</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {adapters.adapters.map((adapter, index) => {
                const isAvailable = adapter.status === 'available';

                return (
                  <TableRow key={adapter.id || index}>
                    <TableCell>
                      <Typography
                        variant="body1"
                        sx={SHARED_TYPOGRAPHY.bodyBold}
                      >
                        {adapter.name}
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={SHARED_TYPOGRAPHY.bodySecondary}
                      >
                        {adapter.description}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Box
                        sx={{
                          display: 'flex',
                          flexWrap: 'wrap',
                          gap: 0.5,
                          maxWidth: 600,
                        }}
                      >
                        {adapter.models?.map(model => (
                          <Chip
                            key={model}
                            label={model}
                            size="small"
                            variant="outlined"
                          />
                        ))}
                      </Box>
                    </TableCell>
                    <TableCell align="center">
                      <Box sx={SHARED_STATUS.container}>
                        <Box sx={getStatusStyles(isAvailable)} />
                        <Typography
                          variant="body2"
                          sx={getStatusTextStyles(isAvailable)}
                        >
                          {isAvailable ? 'Enabled' : 'Disabled'}
                        </Typography>
                      </Box>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </CardContent>
    </Card>
  );
};

export default AdapterStatusTable;
